import QuotesModal from '../../../orders/components/forms/OrderForm/QuotesModal/QuotesModal';
import AdditionalChargeModal from './AdditionalChargeModal/AdditionalChargeModal';
import CCCStandardModal from './CCCStandardModal/CCCStandardModal';
import CostModal from './CostModal';
import InventoryUnitMultipleAddModal from './InventoryUnitMultipleAddModal';
import QuoteLanesModal from 'src/orders/components/forms/OrderForm/QuoteLanesModal/QuoteLanesModal';

export {
  CCCStandardModal,
};

export const warehouseModals = {
  CCC_STANDARD_MODAL: CCCStandardModal,
  ADDITIONAL_CHARGE_MODAL: AdditionalChargeModal,
  COST_MODAL: CostModal,
  INVENTORY_UNIT_MULTIPLE_ADD_MODAL: InventoryUnitMultipleAddModal,
  QUOTE_SELECT_MODAL: QuotesModal,
  QUOTE_LANE_SELECT_MODAL: QuoteLanesModal,
};